import { User as AuthenticatedUser } from 'oidc-client-ts';
import BimTrackConfiguration from '../../app/configuration/BimTrackConfiguration';
import { getCustomAuth } from '../../app/hooks/useCustomAuth';
import { Authentication } from '../../app/modules/authentication';

export default function getAuthentication(): Authentication | undefined {
  const customAuth = getCustomAuth();

  if (customAuth?.user?.access_token) {
    const accessToken = customAuth.user.access_token;

    return {
      accessToken: accessToken,
      logout: () => {},
      refreshAccessToken: () => Promise.resolve(accessToken),
    };
  }

  const { client_id, authority } = BimTrackConfiguration.getOIDCConfiguration();
  const oidcStorage = sessionStorage.getItem(`oidc.user:${authority}:${client_id}`);

  if (!oidcStorage) {
    return undefined;
  }

  const authenticatedUser = AuthenticatedUser.fromStorageString(oidcStorage);

  if (!authenticatedUser?.access_token) {
    return undefined;
  }

  const accessToken = authenticatedUser.access_token;

  return {
    accessToken: accessToken,
    logout: () => {},
    refreshAccessToken: () => Promise.resolve(accessToken),
  };
}
